import React from "react";

import PropTypes from "prop-types";

import { Marker } from "vendor/@react-google-maps/api/reactgooglemapsapi.esm";

function CustomMarker({ position, onClick }) {
  return <Marker position={position} onClick={onClick} />;
}

CustomMarker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func,
};

CustomMarker.defaultProps = {
  onClick: null,
};

export default CustomMarker;
